import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Login from './Login';
import App from './App';

function RootComponent() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // If user has a valid session (within 5 hours), skip login screen
    const FIVE_HOURS = 5 * 60 * 60 * 1000;
    const ts = localStorage.getItem('loginTimestamp');
    if (ts && localStorage.getItem('userId') && localStorage.getItem('email') && localStorage.getItem('displayName')) {
      if (Date.now() - parseInt(ts, 10) < FIVE_HOURS) return true;
      // Expired — clear stale data
      localStorage.removeItem('loginTimestamp');
      localStorage.removeItem('userId');
      localStorage.removeItem('email');
      localStorage.removeItem('displayName');
    }
    return false;
  });

  return (
    <React.StrictMode>
      {isLoggedIn ? <App /> : <Login onLogin={() => setIsLoggedIn(true)} />}
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);